import { FeedbackTypeListTable } from '../components/FeedbackTypeListTable';

export function FeedbackTypeListPage() {
  return <FeedbackTypeListTable />;
}
